// extracted by mini-css-extract-plugin
export default {"container":"_3C68m","title":"hl0Jt","text":"lx-Hf","button":"_1zXTJ"};